import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface Notification {
  id: number;
  message: string;
  type: 'success' | 'error';
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notifications = new BehaviorSubject<Notification[]>([]);
  notifications$ = this.notifications.asObservable();
  private counter = 0;

  success(message: string) {
    this.addNotification(message, 'success');
  }

  error(message: string) {
    this.addNotification(message, 'error');
  }

  private addNotification(message: string, type: 'success' | 'error') {
    const id = this.counter++;
    const notification = { id, message, type };
    this.notifications.next([...this.notifications.value, notification]);

    setTimeout(() => {
      this.removeNotification(id);
    }, type === 'success' ? 3000 : 5000);
  }

  private removeNotification(id: number) {
    const currentNotifications = this.notifications.value;
    this.notifications.next(
      currentNotifications.filter(notification => notification.id !== id)
    );
  }
}
